export default __webpack_public_path__ + "static/media/ricomaMock.80c8bb18.gif";